import { render } from "./tabNotifications.vue?vue&type=template&id=09fa4d40"
import script from "./tabNotifications.vue?vue&type=script&lang=js"
export * from "./tabNotifications.vue?vue&type=script&lang=js"

import exportComponent from "/Users/home/Documents/kevin/migration_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__